import { RichTextStyleWrapper } from "blocks/components/RichTextStyleWrapper";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";

export function Markdown(props: { children: string }) {
  return (
    <RichTextStyleWrapper>
      <ReactMarkdown linkTarget="_blank" rehypePlugins={[rehypeHighlight]}>
        {props.children}
      </ReactMarkdown>
    </RichTextStyleWrapper>
  );
}
